import { render, staticRenderFns } from "./IdentifyingSolutionsBasedOnReactionsSIM.vue?vue&type=template&id=b01a20e0&"
import script from "./IdentifyingSolutionsBasedOnReactionsSIM.vue?vue&type=script&lang=js&"
export * from "./IdentifyingSolutionsBasedOnReactionsSIM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports